// #region imports

import React from 'react';

// Material-UI
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import MembershipHelp from './MembershipHelp';

// #endregion

// #region interfaces

interface MembershipHelplDialogProps {
  handleClose: () => void;
  show: boolean;
}

// #endregion


const MembershipHelpDialog: React.FC<MembershipHelplDialogProps> = (props) => {

  // #region Styles
  // #endregion

  return (
    <Dialog
      open={props.show}
      onClose={props.handleClose}
    >
      <DialogTitle>Membership List</DialogTitle>
      <DialogContent>
        <MembershipHelp />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.handleClose()} color="primary">Close</Button>
      </DialogActions>
    </Dialog>
  );

}

export default MembershipHelpDialog;